import React, { useState } from "react";
import * as httpClient from "../../util/httpClient";
import { getServiceKey, useBureauPermissionCreditReport } from "../../util/credit";
import * as CreditActions from "../../store/credit/actions";
import { useDispatch } from "react-redux";

interface IProps {
    creditTabName: string;
}

const CreditReportExpired: React.FunctionComponent<IProps> = (props: any) => {
    const dispatch = useDispatch();
    const bureauPermission = useBureauPermissionCreditReport();
    const requestCreditData = () => dispatch(CreditActions.actionCreators.requestCreditData(true, bureauPermission));

    const [isLoading, setIsLoading] = useState(false);

    const handleSubmit = (e: any) => {
        setIsLoading(true);
        e.preventDefault();
        const requestBody = {
            "bureau-opt": getServiceKey(bureauPermission),
        };
        httpClient
            .sendRequest("POST", `api/credit-monitoring/refreshCreditData`, requestBody)
            .then((data) => {
                requestCreditData();
                setIsLoading(false);
            })
            .catch(function (error) {
                requestCreditData();
                setIsLoading(false);
            });
    };

    return (
        <div className={`${isLoading && "loading"}`}>
            <h3 className="content-title">Report Expired</h3>
            <div className="row between-xs">
                <div className="col-xs-9 col-gutter-vertical flex-grow-null">
                    {props.creditTabName === "report" && <p>To view your Credit Report you will need to refresh your report.</p>}

                    {props.creditTabName === "simulator" && <p>To view the Credit Simulator you will need to refresh your report.</p>}
                </div>

                <div className="col-xs-3 col-gutter-vertical flex-grow-null">
                    <button
                        type="button"
                        className="btn-default btn-primary"
                        onClick={(e: any) => {
                            handleSubmit(e);
                            window.addToDataLayer({ event: "Refresh Report" });
                        }}
                    >
                        <span className="btn-text">Refresh Report</span>
                    </button>
                </div>
            </div>
        </div>
    );
};

export default CreditReportExpired;
